// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3IzNg","content":"GlobalSearch_content__P6pa3"};